export { default as EyeSplashSolidIcon } from './EyeSplashSolidIcon';
